import { render, staticRenderFns } from "./OthersRose.vue?vue&type=template&id=261920c2&scoped=true&"
import script from "./OthersRose.vue?vue&type=script&lang=js&"
export * from "./OthersRose.vue?vue&type=script&lang=js&"
import style0 from "./OthersRose.vue?vue&type=style&index=0&id=261920c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261920c2",
  null
  
)

export default component.exports